import {configureStore} from "@reduxjs/toolkit";
import {reducer as sessionState} from "./session_state/session_state_reducer";
import {reducer as errors} from "./features/errors/errors";
import {reducer as nav} from "./features/navigation/navigation_reducer";
import {reducer as reg} from "./features/registration/reg_reducer";
import {reducer as regGrid} from "./features/analytics/registrations/reg_grid_slice";
import {reducer as regByOperationGrid} from "./features/analytics/operation/regbyoperation_grid_slice";
import {reducer as regByWorkerGrid} from "./features/analytics/worker/regbyworker_grid_slice";
import {reducer as regByDnGrid} from "./features/analytics/dn/regbydn_grid_slice";
import {reducer as regByMachineGrid} from "./features/analytics/machine/regbymachine_grid_slice";
import {reducer as regByCustomerGrid} from "./features/analytics/customer/regbycustomer_grid_slice";
import api from "./api";
import rootSaga from "./sagas";
import {createRouterMiddleware} from './components/ReduxRouter'
import createSagaMiddleware from "redux-saga";
import {createBrowserHistory} from 'history'

export const history = createBrowserHistory()

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
    reducer: {
        sessionState,
        regGrid,
        errors,
        nav,
        reg,
        regByOperationGrid,
        regByWorkerGrid,
        regByDnGrid,
        regByMachineGrid,
        regByCustomerGrid,
        [api.reducerPath]: api.reducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware()
        .concat([api.middleware, createRouterMiddleware(history)])
        .prepend(sagaMiddleware)
});

sagaMiddleware.run(rootSaga)

export type RootState = ReturnType<typeof store.getState>;
export default store;
